interface OctaPosMarkProps {
  className?: string
  /** Accessible name. Pass null for a decorative mark sitting beside visible text. */
  title?: string | null
}

/**
 * The OctaPOS mark: an "O" set above a "C".
 *
 * Redrawn as vector geometry rather than shipped as a bitmap so it stays sharp at every size
 * from a 16px favicon to a splash screen, weighs a few hundred bytes, and paints in
 * currentColor — which is what lets one file serve the light theme, the dark theme and the
 * receipt header without a second asset.
 *
 * The O is two concentric ellipses filled with the even-odd rule. That is deliberate: a plain
 * stroked ellipse has a uniform width, whereas this glyph is thicker at the sides than at the
 * top, the way a drawn letterform is.
 */
export function OctaPosMark({ className, title = 'OctaPOS' }: OctaPosMarkProps) {
  return (
    <svg
      viewBox="0 0 1024 1024"
      className={className}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : undefined}
      aria-label={title ?? undefined}
      aria-hidden={title ? undefined : true}
    >
      {/* O — outer ellipse then inner ellipse; even-odd punches the counter out. */}
      <path
        fillRule="evenodd"
        d="M 297 311 a 213 179 0 1 0 426 0 a 213 179 0 1 0 -426 0 Z
           M 372 330 a 138 132 0 1 0 276 0 a 138 132 0 1 0 -276 0 Z"
      />
      {/*
        C — an annular sector centred on (487, 672), outer r 215, inner r 138, with the mouth
        opening between -33 and +33 degrees. Endpoints are the exact points at those angles on
        each radius, so the terminals cut clean and the two arcs stay concentric.
      */}
      <path d="M 667 555 A 215 215 0 1 0 667 789 L 603 747 A 138 138 0 1 1 603 597 Z" />
    </svg>
  )
}
